/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useState } from "react";
import AddProduct from "./AddProduct";
import { useDispatch, useSelector } from "react-redux";
import {
  getProduct,
  getProductByID,
  handleActiveProduct,
  handleDuplicateProduct,
  handleProductDelete,
  handleProductImportFile,
} from "../../Redux/ProductSlice";
import { BiEdit, BiPowerOff } from "react-icons/bi";
import { MdContentCopy, MdDeleteForever } from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";
import { IoSearch } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import Loading from "../Common/Loading";
import sweetAlert from "../Common/sweetAlert";
import * as XLSX from 'xlsx';
import { FaPlus } from "react-icons/fa6";
import { RxDotsHorizontal } from "react-icons/rx";
import Pagination from "../Common/Pagination";

const Products = ({
  isVisible,
  setIsVisible,
  setSidebarOpen,
  sidebarOpen,
  isDark,
  setIsDark,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const store = useSelector((state) => state?.root?.Product);

  const [loading, setloading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [sortedField, setSortedField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [AciteOption, setAciteOption] = useState(false);
  const [openActionMenuId, setOpenActionMenuId] = useState(null);

  useEffect(() => {
    const handleOutsideClick = () => setOpenActionMenuId(null);
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  useEffect(() => {
    dispatch(getProduct({})).then((res) => {
      if (res?.payload?.status === true) {
        const timer = setTimeout(() => {
          setloading(false);
        }, 1000);
        return () => clearTimeout(timer);
      }
    });
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const toggleModal = () => {
    setShowModal(!showModal);
    setSelectedProduct("");
  };

  const handleSort = (field) => {

    if (sortedField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortOrder("asc");
      setSortedField(field);
    }
  };

  const sortData = (data, field, order) => {

    const sortedData = [...data];
    sortedData.sort((a, b) => {
      const aTrimmed = a[field]?.trim();
      const bTrimmed = b[field]?.trim();

      if (order === "asc") {
        return aTrimmed?.localeCompare(bTrimmed);
      } else if (order === "desc") {
        // return bTrimmed?.localeCompare(aTrimmed);
      }

    });
    return sortedData;
  };



  const filteredProducts = store?.getProduct ? store?.getProduct.filter((item) => Object.values(item).some((value) => value && value.toString().toLowerCase().includes(searchTerm.toLowerCase()))) : [];

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortData(filteredProducts, sortedField, sortOrder).slice(indexOfFirstRow, indexOfLastRow)
  const totalPages = Math.ceil(filteredProducts?.length / rowsPerPage);


  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleCheckboxChange = (productId) => {
    let updatedSelectedProductIds;

    if (selectedProductIds.includes(productId)) {
      updatedSelectedProductIds = selectedProductIds.filter(
        (id) => id !== productId
      );
    } else {
      updatedSelectedProductIds = [...selectedProductIds, productId];
    }
    setSelectedProductIds(updatedSelectedProductIds);
    const allRowsSelected =
      updatedSelectedProductIds.length === filteredProducts.length;
    setSelectAll(allRowsSelected);
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      const allProductIds = filteredProducts.map((item) => item.productID);
      setSelectedProductIds(allProductIds);
    } else {
      setSelectedProductIds([]);
    }
  };

  const handleEditProduct = async (id) => {
    setShowModal(true);
    await dispatch(getProductByID(id)).then((res) => {
      if (res.payload.status === true) {
        setSelectedProduct(res.payload.data);
      }
    });

  };

  const DeleteProduct = async () => {
    try {
      const result = await sweetAlert.confirm("Are you sure?", "Are you sure you want to delete this!");
      if (result.isConfirmed) {
        dispatch(handleProductDelete(selectedProductIds)).then((res) => {
          if (res.payload.status === true) {
            setCurrentPage(1);
            dispatch(getProduct({}));
          }
        });
        setSelectedProductIds([]);
        setSelectAll(false);
        sweetAlert.success("Deleted successfully");
      }
    } catch (error) {
      console.error("Error:", error);
      sweetAlert.error("An error occurred");
    }
  };

  const handleExport = () => {
    const data = store?.getProduct.map(item => ({
      Name: item.name,
      Code: item.productCode,
      Category: item.category,
      Unit: item.unit,
      unitPrice: item.unitPrice,
      'Tax(%)': item.taxper,
      VisibleTo: item.visibleName,
      Currency: item.currencyName,
      PersonName: item.personMasterName,
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Product");
    XLSX.writeFile(workbook, "Products_data.xlsx");
    setAciteOption(!AciteOption)
  };

  const uploadExcel = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('ExcelFilePath', file);

    setAciteOption(!AciteOption)
    try {
      await dispatch(handleProductImportFile(formData))

    } catch (error) {
      console.error('Upload error:', error);
    }
  };

  const DuplicateProduct = async (id) => {
    await dispatch(handleDuplicateProduct(id)).then((res) => {
      dispatch(getProduct({}));
    }).catch((error) => console.log('error :>> ', error))
  }

  const DeactiveProduct = async (params) => {
    const query = { ProductID: params?.productID, Isactive: params?.isactive === true ? false : true }
    await dispatch(handleActiveProduct(query)).then((res) => {
      dispatch(getProduct({}));
    }).catch((error) => {
      console.log('error :>> ', error);
    })
  }

  const totalProducts = store?.getProduct?.length || 0;
  const activeProducts = store?.getProduct?.filter(p => p?.isactive).length || 0;
  const inactiveProducts = store?.getProduct?.filter(p => !p?.isactive).length || 0;
  const totalCategories = new Set(store?.getProduct?.map(p => p?.categoryName).filter(Boolean)).size || 0;
  const totalUnitValue = store?.getProduct?.reduce((sum, p) => sum + (p?.productPrice?.[0]?.unitprice || 0), 0) || 0;

  return (
    <>
      <div className="flex flex-1">
        <div className="page-wrapper relative ml-auto w-[calc(100%-326px)] px-4 pt-[54px] duration-300">

          {/* Page Header */}
          <div className="crm-page-header">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="crm-page-title">Products</h1>
                <ol className="crm-breadcrumb">
                  <li><a href="/Analytics">Disploy</a></li>
                  <li>/</li>
                  <li>CRM</li>
                  <li>/</li>
                  <li className="active">Products</li>
                </ol>
              </div>
              <button className="crm-new-btn" onClick={() => setShowModal(true)}>
                <FaPlus size={11} />
                New Product
              </button>
            </div>
          </div>

          <div className="xl:w-full min-h-[calc(100vh-138px)] relative pb-14">

            {/* Stat Cards */}
            <div className="crm-stats-row">
              <div className="crm-stat-card crm-card-indigo">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-indigo">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <rect x="2" y="3" width="20" height="14" rx="2" />
                      <path d="M8 21h8M12 17v4" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Total Products</p>
                    <p className="stat-value">{totalProducts}</p>
                    <p className="stat-trend-up">↑ 4% vs last month</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-green">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-green">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Active Products</p>
                    <p className="stat-value">{activeProducts}</p>
                    <p className="stat-trend-up">↑ 5% vs last month</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-red">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-red">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Inactive Products</p>
                    <p className="stat-value">{inactiveProducts}</p>
                    <p className="stat-trend-down">↓ 1% vs last month</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-blue">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-blue">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Categories</p>
                    <p className="stat-value">{totalCategories}</p>
                    <p className="stat-trend-up">↑ 2% vs last month</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-orange">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-orange">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <line x1="12" y1="1" x2="12" y2="23" />
                      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Total Unit Value</p>
                    <p className="stat-value">₹{totalUnitValue.toLocaleString('en-IN')}</p>
                    <p className="stat-trend-up">↑ 8% vs last month</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="crm-panel">
              <div className="flex items-center justify-end px-4 py-3 border-b border-slate-100 gap-3 flex-wrap">
                <div className="crm-search-box">
                  <IoSearch size={14} />
                  <input
                    type="text"
                    placeholder="Search products..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>

                {selectedProductIds && selectedProductIds.length > 0 && (
                  <button
                    className="p-2 rounded-lg text-red-500 hover:bg-red-50 transition-colors"
                    onClick={DeleteProduct}
                    title="Delete Selected"
                  >
                    <MdDeleteForever size={18} />
                  </button>
                )}

                <div className="relative">
                  <button
                    type="button"
                    className="p-2 hover:bg-slate-50 border border-slate-200 rounded-lg text-slate-500 hover:text-slate-800 transition-colors"
                    onClick={() => setAciteOption(!AciteOption)}
                  >
                    <RxDotsHorizontal size={16} />
                  </button>
                  {AciteOption && (
                    <div className="absolute right-0 mt-1 w-44 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 text-left">
                      {currentRows.length > 0 && (
                        <button
                          onClick={handleExport}
                          className="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
                        >
                          Export file results
                        </button>
                      )}
                      <label className="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors cursor-pointer block">
                        <input
                          type="file"
                          className="hidden"
                          onChange={uploadExcel}
                          accept=".xls,.xlsx"
                        />
                        Import Data
                      </label>
                    </div>
                  )}
                </div>
              </div>
              {loading && (<div className="h-screen"><Loading /></div>)}
              {!loading && (
                <>
                  <div className="relative scroll-inner">
                    <table className="crm-table">
                      <thead>
                        <tr className="text-center">
                          <th scope="col" className="w-4 p-4 text-center">
                            <label className="custom-label">
                              <div className="bg-white dark:bg-slate-600/40 border border-slate-300 dark:border-slate-600 rounded w-4 h-4 inline-block leading-4 text-center -mb-[3px]">
                                <input
                                  type="checkbox"
                                  checked={selectAll}
                                  onChange={() => handleSelectAll()}
                                />
                              </div>
                            </label>
                          </th>
                          <th scope="col" className="mw-200 p-4">
                            <div className="flex justify-center items-center w-full">
                              Name
                              <svg
                                className="w-3 h-3 ms-1.5 cursor-pointer"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                                onClick={() => handleSort("name")}
                              >
                                <path
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Zm-6.852 0 3.426 5.05-3.426-5.05Z"
                                />
                              </svg>
                            </div>
                          </th>
                          <th scope="col" className="mw-200 p-4">Product Code</th>
                          <th scope="col" className="mw-200 p-4">Category</th>
                          <th scope="col" className="mw-200 p-4">Currency</th>
                          <th scope="col" className="mw-200 p-4">Unit prices</th>
                          <th scope="col" className="mw-200 p-4">Tax (%)</th>
                          <th scope="col" className="mw-200 p-4">Unit</th>
                          <th scope="col" className="mw-200 p-4">Price (INR)</th>
                          <th scope="col" className="mw-200 p-4">Visible to</th>
                          <th scope="col" className="mw-200 p-4">Status</th>
                          <th scope="col" className="mw-200 p-4">Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentRows && currentRows.length > 0 ? (
                          currentRows.map((item, index, arr) => {
                            const showUpward = index >= arr.length - 2 && arr.length > 1;
                            return (
                              <tr
                                className="hover:bg-slate-50 transition-colors border-b border-slate-100 text-center"
                                key={index}
                              >
                                <td className="w-4 p-4 text-center">
                                  <label className="custom-label">
                                    <div className="bg-white dark:bg-slate-600/40 border border-slate-200 dark:border-slate-600 rounded w-4 h-4 inline-block leading-4 text-center -mb-[3px]">
                                      <input
                                        type="checkbox"
                                        checked={selectedProductIds.includes(
                                          item.productID
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(item.productID)
                                        }
                                      />
                                    </div>
                                  </label>
                                </td>
                                <td
                                  className="capitalize mw-200 px-4 py-3 text-sm font-semibold text-slate-700 hover:text-indigo-600 cursor-pointer whitespace-nowrap text-center"
                                  onClick={() => navigate(`/products/${item?.productID}`)}
                                >
                                  {item?.name}
                                </td>
                                <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap text-center">
                                  {item?.productCode}
                                </td>
                                <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap text-center">
                                  {item?.categoryName}
                                </td>
                                <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap text-center">
                                  {item?.productPrice?.length > 0 && item?.productPrice[0]?.currencyName}
                                </td>
                                <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap text-center font-medium text-slate-600">
                                  {item?.productPrice?.length > 0 && item?.productPrice[0]?.currencyCode} &nbsp;
                                  {item?.productPrice?.length > 0 && item?.productPrice[0]?.unitprice?.toLocaleString('en-PK')}
                                </td>
                                <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap text-center">
                                  {item?.taxper}
                                </td>
                                <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap text-center">
                                  {item?.unit}
                                </td>
                                <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap text-center">
                                  {/* Price INR */}
                                </td>
                                <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap text-center">
                                  {item?.visibleName}
                                </td>
                                <td className="mw-200 px-4 py-3 text-sm whitespace-nowrap text-center">
                                  <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${item?.isactive ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
                                    {item?.isactive ? 'ACTIVE' : 'INACTIVE'}
                                  </span>
                                </td>
                                <td className="p-3 text-center whitespace-nowrap">
                                  <div className="relative inline-block text-left">
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenActionMenuId(openActionMenuId === item.productID ? null : item.productID);
                                      }}
                                      className="p-1.5 text-slate-500 hover:text-slate-800 hover:bg-slate-100 rounded-lg transition-colors"
                                    >
                                      <BsThreeDotsVertical size={16} />
                                    </button>
                                    {openActionMenuId === item.productID && (
                                      <div className={`absolute right-0 w-36 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 animate-in fade-in duration-100 flex flex-col ${showUpward ? 'bottom-full mb-1 slide-in-from-bottom-1' : 'top-full mt-1 slide-in-from-top-1'}`}>
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleEditProduct(item.productID);
                                            setOpenActionMenuId(null);
                                          }}
                                          className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                        >
                                          <BiEdit size={14} className="text-indigo-500" />
                                          <span>Edit</span>
                                        </button>
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            DuplicateProduct(item?.productID);
                                            setOpenActionMenuId(null);
                                          }}
                                          className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                        >
                                          <MdContentCopy size={14} className="text-indigo-500" />
                                          <span>Copy</span>
                                        </button>
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            DeactiveProduct(item);
                                            setOpenActionMenuId(null);
                                          }}
                                          className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                        >
                                          <BiPowerOff size={14} className="text-indigo-500" />
                                          <span>{item?.isactive ? 'Deactivate' : 'Activate'}</span>
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="12" className="text-center py-4 text-slate-500">
                              Not Found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagination setCurrentPage={setCurrentPage} handlePageChange={handlePageChange} currentPage={currentPage} sidebarOpen={sidebarOpen} totalPages={totalPages} length={filteredProducts?.length} setrowsPerPage={setrowsPerPage} rowsPerPage={rowsPerPage} name='Products' />
                </>
              )}
            </div>
          </div>
        </div>

        {showModal && (
          <AddProduct toggleModal={toggleModal} product={selectedProduct} />
        )}
      </div>
    </>

  );
};

export default Products;

